import React, { useEffect } from 'react'
import "./Order_details_table.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashCan } from '@fortawesome/free-solid-svg-icons'
import { Form, Table } from 'react-bootstrap'
import { IDS } from '../../../../../../utils/IDS'
import { AllAppsetup } from '../../../../../../features/admin/footer/Slice'
import { useDispatch, useSelector } from 'react-redux'

function Order_details_table({ Order = {}, dontShowPrice, showCheck = false, showReturn = false, products, selectedItems,
  setSelectedItems,
  setError, }) {
  const handleCheckboxChange = (val) => {
    setError("");
    setSelectedItems((prev) => {
      const exists = prev.some((item) => item.id === val.id);
      if (exists) {
        return prev.filter((item) => item.id !== val.id);
      } else {
        return [...prev, val];
      }
    });
  };
  const dispatch = useDispatch()
  const app_setup = useSelector((state) => state.footer.app_setup);
  useEffect(() => {
    dispatch(AllAppsetup());
  }, [dispatch]);
  return (
    <>
      <div className='product_content_holder'>
        <div className='product_content'>
          {products?.map((product) => {

            const orderDate = Order?.createdAt ? new Date(Order.createdAt) : null;

            let isReturn = false;

            if (orderDate && app_setup?.return_days) {
              const today = new Date();
              const lastReturnDate = new Date(orderDate);
              lastReturnDate.setDate(orderDate.getDate() + Number(app_setup.return_days));

              isReturn =
                today <= lastReturnDate &&
                product?.Product?.is_returnable;
            }


            return (
              <div className='product_detail_inner' key={product.id}>
                <div className='left_side'>
                  {(showCheck || showReturn) && (
                    <Form.Check
                      type="checkbox"
                      className="cancel_check"
                      disabled={showReturn && !isReturn}
                      checked={selectedItems?.some((item) => item.id === product.id)}
                      onChange={() => handleCheckboxChange(product)}
                    />
                  )}


                  <div className='img_holder'>
                    <img
                      src={IDS.IMG_URL + product?.Product?.image}
                    />
                  </div>

                  <div className='text_holder'>
                    <div className='product_name'>
                      <p>{product?.Product?.name || " "}</p>
                    </div>
                    {/* <p className='text-danger mt-2'></p> */}
                    <div className='weight'>
                      {showReturn && !product?.Product?.is_returnable && (
                        <p className="text-danger">This product is not returnable</p>
                      )}
                    </div>

                  </div>
                </div>

                <div>
                  <div className='qty_holder'>
                    <p>x {product?.quantity || "0"} {!dontShowPrice && <span className='price'>₹{Number(product?.Product?.price).toFixed(2) || "0"}</span>}</p>
                  </div>
                </div>

              </div>
            )
          })}


          {/* <div className='product_detail_inner'>
            <div className='left_side'>
              <div className='img_holder'>
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/assets/images/explore/top-products/product1.png"
                  }
                />
              </div>

              <div className='text_holder'>
                <div className='product_name'>
                  <p>Agarbatti <span className='inner_text'>(Rose)</span></p>
                </div>
                
              </div>
            </div>

            <div>
              <div className='qty_holder'>
                <p>x 1 {!dontShowPrice && <span className='price'>₹ 120</span>}</p>
              </div>
            </div>

          </div> */}

          {/* <div className='product_detail_inner'>
            <div className='left_side'>
              <div className='img_holder'>
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/assets/images/explore/top-products/product2.png"
                  }
                />
              </div>

              <div className='text_holder'>
                <div className='product_name'>
                  <p>Rudraksh  <span className='inner_text'>(5 Faces)</span></p>
                </div>
              </div>
            </div>

            <div>
              <div className='qty_holder'>
                <p>x 1 {!dontShowPrice && <span className='price'>₹ 120</span>}</p>
              </div>
            </div>

          </div> */}
        </div>
      </div>
    </>
  )
}

export default Order_details_table
